import { useEffect } from 'react';

import type React from 'react';

import { fieldError, setClass } from '../../helpers/utils';
import './styles.scss';

type CheckboxProps = {
	name?: string;
	label?: React.ReactNode;
	checked?: boolean;
	disabled?: boolean;
	dataId?: unknown;
	className?: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	value?: string | number;
	hookForm?: any;
};

export const Checkbox = ({
	name = '',
	label,
	checked,
	disabled,
	dataId,
	className = '',
	onChange,
	value,
	hookForm = { formState: { errors: {} } },
}: CheckboxProps) => {
	const {
		register,
		setValue,
		formState: { errors },
	} = hookForm;

	const handleChange = (event) => {
		setValue(name, event.target.checked);
		if (typeof onChange === 'function') {
			onChange(event);
		}
	};

	useEffect(() => {
		setValue(name, checked);
	}, [checked]);

	return (
		<div
			className={setClass(`checkbox
        ${fieldError(errors, name) ? 'is-error' : ''}
        ${disabled ? 'is-disabled' : ''}
        ${!label ? 'is-notlabel' : ''}
        ${className}`)}
		>
			<label>
				<input
					type="checkbox"
					name={name}
					value={value}
					data-id={dataId}
					// checked={checked}
					defaultChecked={checked}
					disabled={disabled}
					{...register?.(name, {
						onChange: (e) => handleChange(e),
					})}
				/>
				<span>{label}</span>
				<div className="check"></div>
			</label>
			{fieldError(errors, name) && (
				<span className="message-error">
					{(fieldError(errors, name) as any).message}
				</span>
			)}
		</div>
	);
};
